import { z } from 'zod';

export const objectIdSchema = z.string().regex(/^[0-9a-f]{24}$/i, 'Invalid ObjectId');
export const slugSchema = z
  .string()
  .min(2)
  .max(80)
  .regex(/^[a-z0-9](?:[a-z0-9-]{0,78}[a-z0-9])?$/, 'Invalid slug');

export const localeSchema = z.enum(['es', 'en']);
export type LocaleSchema = z.infer<typeof localeSchema>;

export const isoDateString = z
  .string()
  .refine((v) => !Number.isNaN(Date.parse(v)), 'Invalid ISO date');

export const currencyCodeSchema = z
  .string()
  .length(3)
  .regex(/^[A-Z]{3}$/, 'Invalid ISO 4217 currency code');

export const priceCentsSchema = z.number().int().nonnegative();

export const paginationSchema = z.object({
  cursor: z.string().optional(),
  limit: z.number().int().min(1).max(100).default(20),
});
export type Pagination = z.infer<typeof paginationSchema>;

export const baseDocSchema = z.object({
  _id: objectIdSchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullable().optional(),
});
